import { endpoints } from "../../site/configuration/endpoints";
import { CustomerUserDto } from "../types/SpareParts/CustomerUserDto";
import { PartApplicability } from "../types/SpareParts/PartApplicability";
import { PartDetails } from "../types/SpareParts/PartDetails";
import ApiGateway from "./ApiGateway";

export class SparePartsService {
    public getPartDetails = (
        manufacturer: string,
        partCode: string,
        lang: string
    ): Promise<PartDetails> => {
        return new Promise<PartDetails>((resolve, reject) => {
            ApiGateway()
                .get<PartDetails>(
                    endpoints.spareParts.partDetails
                        .replace("{manufacturer}", manufacturer)
                        .replace("{partCode}", partCode) +
                    "?lang=" +
                    lang
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(new Error(error)));
        });
    };
    public getPartApplicabilities = (
        brand: string,
        manufacturer: string,
        partCode: string,
        lang: string,
        siteCode?: string
    ): Promise<PartApplicability[]> => {
        return new Promise<PartApplicability[]>((resolve, reject) => {
            ApiGateway()
                .get<PartApplicability[]>(
                    endpoints.spareParts.partApplicabilities
                        .replace("{brand}", brand)
                        .replace("{manufacturer}", manufacturer)
                        .replace("{partCode}", partCode) +
                    (siteCode ? "/" + siteCode : "") +
                    "?lang=" +
                    lang
                )
                .then((result) => {
                    return resolve(result.data);
                })
                .catch((error) => reject(new Error(error)));
        });
    };

    public getUsersToTransfer = (brand: string): Promise<CustomerUserDto[]> => {
        return new Promise<CustomerUserDto[]>((resolve, reject) => {
            ApiGateway()
                .get<CustomerUserDto[]>(
                    endpoints.spareParts.getUsersToTransfer.replace("{brand}", brand)
                )
                .then((result) => resolve(result.data))
                .catch((error) => reject(error));
        });
    };
}
